const DjangoLogo = () => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 128 128"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="skill-icon"
    >
      <path
        d="M59.4482 0H80.3781V96.88C69.6411 98.92 61.7581 99.735 53.1971 99.735C27.6461 99.734 14.3271 88.184 14.3271 66.03C14.3271 44.692 28.4621 30.83 50.3421 30.83C53.7401 30.83 56.3222 31.102 59.4482 31.917V0ZM59.4482 48.765C57.0022 47.95 54.9632 47.679 52.3811 47.679C41.7811 47.679 35.6642 54.202 35.6642 65.618C35.6642 76.763 41.5091 82.878 52.2461 82.878C54.5551 82.878 56.4581 82.742 59.4482 82.336V48.765Z"
        fill="#00E96C"
      />
      <path
        d="M113.672 32.3211V80.8401C113.672 97.5571 112.448 105.575 108.779 112.506C105.381 119.167 100.896 123.379 91.6552 128L72.2202 118.759C81.4622 114.409 85.9462 110.606 88.8002 104.759C91.7902 98.7801 92.7432 91.8491 92.7432 73.6371V32.3211H113.672ZM92.7422 0.111084H113.672V21.5851H92.7422V0.111084Z"
        fill="#00E96C"
      />
    </svg>
  );
};

export default DjangoLogo;
